import io from 'socket.io-client';

const socket = io(process.env.REACT_APP_API.replace(/\/api$/, ""), {
  transports: ['websocket'],
  autoConnect: false,
});

export default socket;
